import React from 'react';
import './KeyValueCard.scss';
interface KeyValueCardProps {
  data: {
    label: React.ReactNode;
    value: React.ReactNode;
  }[];
  className?: string;
}
const KeyValueCard = ({
  data,
  className = ''
}: KeyValueCardProps): JSX.Element | null => {
  if (data.length === 0) {
    return null;
  }
  return (
    <div className={`key-value-card-wrapper ${className}`}>
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <p className="key">{item.label}</p>
          <p>:</p>
          <p className="value">{item.value}</p>
        </React.Fragment>
      ))}
    </div>
  );
};
export default KeyValueCard;
